module.exports = __webpack_public_path__ + "static/img/calendar.205601e8.png";